import React from 'react'
import PropTypes from 'prop-types'

import _ from 'lodash'

import { withStyles } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'

import Auth from './auth/Auth'
import Error from './components/Error'
import Header from './components/Header'
import Main from './components/Main'
import SideMenu from './components/SideMenu'

import AuthAPI from './api/AuthAPI'

// Import constants
// import { } from './constants'

// Instantiate the auth service
const authAPI = new AuthAPI()

// Instantiate the auth class
const auth = new Auth()


const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100%',
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
    minWidth: 0, // So the Typography noWrap works
  },
  toolbar: theme.mixins.toolbar,
});

class App extends React.Component {

  constructor() {
    super()
    this.state = {
      error: '',
      apiKey: '',
      clientId: '',
      profile: {}
    }
    this.handleAuthentication = this.handleAuthentication.bind(this)
    this.handleLogin = this.handleLogin.bind(this)
    this.handleLogout = this.handleLogout.bind(this)
    this.handleRefreshProfile = this.handleRefreshProfile.bind(this)
  }

  handleAuthentication({location}) {
    if (/access_token|error/.test(location.hash)) {
      auth.handleAuthentication()
    }
  }

  handleLogin() {
    auth.login()
  }

  handleLogout() {
    auth.logout()
    this.setState({
      apiKey: '',
      clientId: '',
      profile: {}
    })
  }

  async handleRefreshProfile() {
    const { profile } = this.state
    if (_.isEmpty(profile)) {
      try {
        const profile = await auth.getProfile()
        // DEBUG && console.log(JSON.stringify(profile, null, 2))
        const clientId = _.first(auth.getGroups()) // TODO: Handle multiple clients
        // DEBUG && console.log(clientId)
        const [profiles, keys] = await Promise.all([
          await authAPI.getProfile(),
          await authAPI.getKey()
        ])
        let prefs = _.get(profiles, clientId)
        // DEBUG && console.log(JSON.stringify(prefs, null, 2))
        let apiKey = _.get(keys, clientId)
        // DEBUG && console.log(apiKey)
        this.setState({ apiKey, clientId, profile: { ...profile, prefs } })
      } catch (err) {
        console.error('Error refreshing profile')
        throw err
      }
    }
  }

  render() {
    const { classes } = this.props
    const { apiKey, clientId, profile } = this.state
    return (
      <React.Fragment>
        <CssBaseline />
        <div className={classes.root}>
          <Header
            handleLogin={this.handleLogin}
            handleLogout={this.handleLogout}
            isAuthenticated={auth.isAuthenticated()}
            profile={profile}
          />
          <SideMenu />
          <main className={classes.content}>
            <div className={classes.toolbar} />
            <Error>
              <Main
                handleAuthentication={this.handleAuthentication}
                handleLogin={this.handleLogin}
                handleLogout={this.handleLogout}
                handleRefreshProfile={this.handleRefreshProfile}
                isAuthenticated={auth.isAuthenticated()}
                isSetup={auth.hasGroup() && auth.hasRole()}
                apiKey={apiKey}
                clientId={clientId}
                profile={profile}
              />
            </Error>
          </main>
        </div>
      </React.Fragment>
    )
  }

}

App.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(App)
